<div>
    <div id="busy-overlay" class="component-overlay" *ngIf="isBusy">
        <div class="center">
          <mat-spinner color="accent" [diameter]="48"></mat-spinner>
        </div>
    </div>
    <div style="margin-bottom: 24px;">
        <button mat-button *ngIf="!hasCsLocationSetup" color="accent" (click)="initializeCsLocationSetup('csLocationSetup')">
            <mat-icon>add</mat-icon>
            STANDORTPLANUNG HINZUFÜGEN
        </button>
        <button mat-button *ngIf="!hasInstallationDescription" color="accent" (click)="initializeInstallationDescription()">
            <mat-icon>add</mat-icon>
            INSTALLATIONSBESCHREIBUNG HINZUFÜGEN
        </button>
        <button mat-button *ngIf="!hasInstallationSection" color="accent" (click)="initializeInstallationSection('csInstallation')">
            <mat-icon>add</mat-icon>
            INSTALLATIONSARBEITEN HINZUFÜGEN
        </button>
        <button mat-button *ngIf="!hasGridConnectionSection" color="accent" (click)="initializeGridConnectionSection('gridConnection')">
            <mat-icon>add</mat-icon>
            NETZANSCHLUSS HINZUFÜGEN
        </button>
    </div>
    <div style="width: 100%; height: 100%;">
        <div [hidden]="!hasInstallationDescription" style="margin-top: 24px;padding-right: 16px;">
            <app-installation-description #installationDescriptionComponent 
                                          [text]="installationDescription?.text"
                                          (discardChangesCalled)="discardInstallationDescriptionChanges()"
                                          (saveChangesCalled)="saveInstallationDescription($event)"
                                          (deleteCalled)="deleteInstallationDescription()">
            </app-installation-description>
        </div>
        
        <a id="csLocationSetup"></a>
        <div id="csLocationSetup" *ngIf="hasCsLocationSetup" style="margin-top: 24px;">
            <mat-divider style="margin-bottom: 12px;"></mat-divider>
            <h2>Standortplanung</h2>
            <app-location-setup #csLocationSetupComponent
                                [csLocationSetup]="csLocationSetup"
                                (discardChangesCalled)="discardCsLocationSetupChanges()"
                                (saveChangesCalled)="saveCsLocationSetupChanges($event)"
                                (deleteCalled)="deleteCsLocationSetup()">
            </app-location-setup>
        </div>
        <a id="csInstallation"></a>
        <div [hidden]="!hasInstallationSection" style="margin-top: 24px;">
            <mat-divider style="margin-bottom: 12px;"></mat-divider>
            <h2>Installation</h2>
            <div style="position: relative;">
                <app-entries-table #installationTable 
                                [productsDataSource]="installationActivities"
                                [productFilter]="installationActivitiesFilter"
                                [originalEntries]="installationSection"
                                [publishTotalCosts]="true"
                                (productFilterDiscarded)="installationActivitiesFilterDiscarded()"
                                (discardChangesCalled)="discardInstallationSectionChanges()"
                                (saveChangesCalled)="saveInstallationSectionChanges($event)"
                                (deleteCalled)="deleteInstallationSection()"></app-entries-table>
                <div style="display: flex; position: absolute; top: 0; vertical-align: middle; width: 350px; margin-left: 24px; margin-top: 12px;">
                    <mat-label style="margin-right: 8px;">Überregional: </mat-label>
                    <mat-checkbox 
                        [disabled]="installationTable.isReadonly" 
                        [checked]="supraregionalInstallation"
                        (change)="supraregionalInstallationChecked($event.checked)"></mat-checkbox>
                </div>
            </div>
        </div>
        <a id="gridConnection"></a>
        <div [hidden]="!hasGridConnectionSection" style="margin-top: 24px;">
            <mat-divider style="margin-bottom: 12px;"></mat-divider>
            <h2>Netzanschluss</h2>
            <div style="position: relative;">
                <app-entries-table #csGridConnectionTable
                                [productsDataSource]="selectedGridProvider?.products"
                                [originalEntries]="gridConnectionSection"
                                [publishTotalCosts]="true"
                                [ignoreCustomPositionsForStateDetermination] = "gridProviderWasDeleted"
                                (discardChangesCalled)="discardGridConnectionSectionChanges()"
                                (saveChangesCalled)="saveGridConnectionSectionChanges($event)"
                                (deleteCalled)="deleteGridConnectionSection()"></app-entries-table>
                <div style="display: flex; position: absolute; top: 0; vertical-align: middle; width: 350px; margin-left: 24px; margin-top: 12px;">
                    <mat-label style="margin-right: 8px;">Netzbetreiber: </mat-label>
                    <div *ngIf="csGridConnectionTable.isReadonly"
                         [class.deleted] = "gridProviderWasDeleted && csGridConnectionTable.displayProductUpdates">
                         {{gridConnectionSection?.gridProviderName}}
                    </div>
                    <mat-select *ngIf="!csGridConnectionTable.isReadonly" style="display: inline-block;" [(value)]="selectedGridProvider">
                        <mat-option *ngFor="let provider of gridProviders" [value]="provider">
                        {{provider.name}}
                        </mat-option>
                        </mat-select>
                </div>
            </div>
            
        </div>
    </div>
</div>
